import { render, staticRenderFns } from "./allQuery.vue?vue&type=template&id=06021eca&scoped=true&"
import script from "./allQuery.vue?vue&type=script&lang=js&"
export * from "./allQuery.vue?vue&type=script&lang=js&"
import style0 from "./allQuery.vue?vue&type=style&index=0&id=06021eca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06021eca",
  null
  
)

export default component.exports